import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LaunchDarklyFlags } from 'app/core/services/launch-darkly/launch-darkly.types';
import { WarningMessage } from 'app/core/services/launch-darkly/launch-darkly.types';
import { getFeatureFlagObservable } from 'app/core/state';
import { AppState } from 'app/types';

export interface ModalSimpleSocialData {
  modalTitle: string;
  text: string;
  primaryButtonText: string;
  primaryButtonIcon?: string;
  secondaryButtonText?: string;
  secondaryButtonIcon?: string;
  tertiaryButtonText?: string;
  customButtonText?: string;
  customButtonIcon?: string;
  help?: boolean;
}

@Component({
  selector: 'app-modal-simple-social',
  templateUrl: './modal-simple-social.component.html',
  styleUrls: ['./modal-simple-social.component.scss'],
  standalone: false,
})
export class ModalSimpleSocialComponent implements OnInit, OnDestroy {
  protected data = inject<ModalSimpleSocialData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ModalSimpleSocialComponent>>(MatDialogRef);
  private store = inject<Store<AppState>>(Store);

  public warningMessage?: WarningMessage;

  private destroyed$ = new ReplaySubject<boolean>(1);

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public ngOnInit(): void {
    if (this.data.help) {
      getFeatureFlagObservable(this.store, LaunchDarklyFlags.social_error_banner)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((warningMessage) => (this.warningMessage = warningMessage));
    }
  }

  public cancelButtonClicked(): void {
    this.dialogRef.close('tertiary');
  }

  public confirmButtonClicked(): void {
    this.dialogRef.close('primary');
  }

  public secondaryButtonClicked(): void {
    this.dialogRef.close('secondary');
  }

  public closeDetail(): void {
    this.dialogRef.close('close');
  }

  public customButtonClicked(): void {
    this.dialogRef.close('custom');
  }
}
